var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgSoundSpeakerOn = function SvgSoundSpeakerOn(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 23",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.1.2a.8.8 0 0 1 1.3.7v20.8a.8.8 0 0 1-1.3.6L5.3 16H1.6C.7 16 0 15.3 0 14.5V8c0-1 .7-1.6 1.6-1.6h3.7zm6.5 3.1c.3-.3.8-.3 1.1 0a11 11 0 0 1 3.3 8c0 3-1.2 5.8-3.3 7.9a.8.8 0 0 1-1.1-1.2 9.5 9.5 0 0 0 0-13.5.8.8 0 0 1 0-1.2zm-2.3 2.3c.3-.3.8-.3 1.1 0a7.9 7.9 0 0 1 2.4 5.7c0 2.1-.8 4.1-2.4 5.6a.8.8 0 0 1-1 0 .8.8 0 0 1 0-1.1 6.3 6.3 0 0 0 1.8-4.5c0-1.8-.7-3.4-1.9-4.6a.8.8 0 0 1 0-1.1z",
    fillRule: "evenodd"
  })));
};
export default SvgSoundSpeakerOn;